<template>
  <div class="h-100 d-flex flex-column justify-content-center pb-5 px-3">
    <!-- <button :class="'outlined-grey mt-3'" @click="goToPse()">
      Efectivo
    </button> -->
    <!--  <pay-u-button
      :selectedPlan="selectedPlan"
      :isRecharge="isRecharge"
      :buttonLabel="'Efectivo'"
      :buttonClass="'outlined-grey mt-3'"
      :isCash="true"
    /> -->
    <div v-for="method in paymentsMethods" :key="method.label">
      <directa-button
        v-if="method.type == 'directa24'"
        :selectedPlan="selectedPlan"
        :isRecharge="isRecharge"
        :buttonLabel="method.label"
        :buttonClass="'outlined-grey mt-3'"
        :isCash="true"
      />
      <button
        v-if="method.type == 'bancolombia'"
        :class="'outlined-grey mt-3'"
        @click="goTo('bancolombia')"
      >
        {{ method.label }}
      </button>
      <whatsapp-button
        v-if="method.type == 'cash'"
        :phone="company_data.client_service"
        :text="
          'Buenos días, estoy tratando de realizar un pago en la ciudad de ' +
            kCity +
            ' en la categoría ' +
            kCategory +
            ' con el número de teléfono ' +
            user.username
        "
        :buttonlabel="method.label"
        :buttonClass="'outlined-grey mt-3 w-100'"
      />
    </div>

    <!-- <button :class="'outlined-grey mt-3 mb-5'" @click="goToPse()">
      Otros Bancos
    </button> -->
  </div>
</template>

<script>
/* import PayUButton from "@/components/UI/PayUButton" */
import DirectaButton from "@/components/UI/DirectaButton"
import settings from "@/api/settings"
import WhatsappButton from "@/components/UI/WhatsappButton.vue"
import plansApi from "@/api/plans"
import { mapGetters } from "vuex"
export default {
  props: ["selectedPlan", "isRecharge"],
  data() {
    return {
      company_data: settings.company_data,
      paymentsMethods: settings.paymentsMethods,
    }
  },
  components: {
    WhatsappButton,
    DirectaButton,
    /* PayUButton, */
  },
  methods: {
    goToPse() {
      this.$router.push({ path: "plans", query: { steps: "pse" } })
    },
    goTo(method) {
      if (!this.isRecharge) {
        plansApi
          .payUPaymentRequest(
            this.user.kProfile,
            this.selectedPlan._id,
            //discount it'll change=
            1,
            this.selectedPlan.price,
            "bancolombia"
          )
          .then(apiResponse => {
            console.log(apiResponse, "apiResponse", this)
            //const { payment, signature, referenceCode } = apiResponse
            this.$router.push({
              path: "plans",
              query: { steps: method, navbarT: method },
            })
          })
      } else {
        console.log(
          this.user.id,
          this.selectedPlan.promo_on_credits,
          this.selectedPlan.price,
          "RECARGA BANCOLOMBIA"
        )
        plansApi
          .payURechargeRequest(
            this.user.id,
            this.selectedPlan.promo_on_credits,
            this.selectedPlan.price,
            "bancolombia"
          )
          .then(apiResponse => {
            console.log(apiResponse, "apiResponse", this)
            //const { payment, signature, referenceCode } = apiResponse
            this.$router.push({
              path: "plans",
              query: { steps: method, navbarT: method },
            })
          })
      }
    },
    /*  goTo(method) {
      // solo pra cuando sea para bancoombia se genera un ticket
      this.$router.push({ path: "plans", query: { steps: method } })
    }, */
  },
  computed: { ...mapGetters(["user", "kCity", "kCategory"]) },
}
</script>

<style></style>
